<template>
  <div ref="page_service" v-if="page.clients" class="page page-white page-clients">
    <div class="container">
      <div v-html="page.clients.text_lead" class="lead lead-intro col-md-12"/>
      <div class="col-md-12">
        <h1>{{ page.clients.title }}</h1>
      </div>
      <div class="col-md-12 slider-service">
        <Slider/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import PopupDocuments from '@/components/PopupDocuments';
import Slider from '@/components/SliderBig';

require('@/assets/css/swiper.css');

export default {
  name: 'clients',
  components: {
    PopupDocuments,
    Slider,
  },
  computed: mapGetters({
    page: 'page',
  }),
};
</script>


<style>
.page{
  &-clients{
    padding-bottom: 20px;
    position: relative;
    z-index: 11;

    @media (max-width: $mediaTiny) {
      min-height: 500px;
    }

    .lead-intro{
      min-height: 220px;
    }

    h1{
      position: relative;
      z-index: 999;
    }
    .slider-service{
      transition: opacity 1s ease-in-out;
    }
    .page-theme-dark &.page-white{
      .slider-service{
        opacity: 0;
      }
    }
    .page-theme-white &.page-dark{
      .slider-service{
        opacity: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Clients.vue